import React from 'react';
import { Drawer, Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
import type { TrackExportErrorDetail } from '../services/trackExportApi';

interface TrackExportErrorDrawerProps {
  visible: boolean;
  onClose: () => void;
  errorDetail: TrackExportErrorDetail | null;
}

const TrackExportErrorDrawer: React.FC<TrackExportErrorDrawerProps> = ({
  visible,
  onClose,
  errorDetail,
}) => {
  const { t } = useTranslation();

  return (
    <Drawer
      title={t('central.trackExport.error.title')}
      placement="right"
      width={480}
      onClose={onClose}
      open={visible}
    >
      {errorDetail && (
        <Descriptions column={1} bordered size="small">
          <Descriptions.Item label={t('central.trackExport.error.reason')}>
            {errorDetail.reason}
          </Descriptions.Item>
          {errorDetail.invalidRows && errorDetail.invalidRows.length > 0 && (
            <Descriptions.Item label={t('central.trackExport.error.invalidRows')}>
              {errorDetail.invalidRows.join(', ')}
            </Descriptions.Item>
          )}
          {errorDetail.sample && (
            <Descriptions.Item label={t('central.trackExport.error.sample')}>
              {errorDetail.sample}
            </Descriptions.Item>
          )}
          {errorDetail.message && (
            <Descriptions.Item label={t('central.trackExport.error.message')}>
              {errorDetail.message}
            </Descriptions.Item>
          )}
        </Descriptions>
      )}
    </Drawer>
  );
};

export default TrackExportErrorDrawer;
